// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_promotion,
  add_promotion,
  update_promotion,
  delete_promotion,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";
const getTodayDate = () => {
    const today = new Date();
    const offset = today.getTimezoneOffset();
    today.setMinutes(today.getMinutes() - offset);
    return today.toISOString().split("T")[0];
  };
const initialState = {
  promotions: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    from_school_class :"",
    from_section :"",
    from_session :"",
    to_school_class :"",
    to_section :"",
    to_session :"",
    remarks :"",
  },
  filterData: {
    date: getTodayDate()||"",
    section: "",
    school_class: "",
    student: ""
  },
};

// Async Thunks for API Calls
export const fetchpromotion = createAsyncThunk(
  "promotion/fetchpromotion",
  async (
    { page, page_size, school_id,token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_promotion(
        page,
        page_size,
        school_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createpromotion = createAsyncThunk(
  "promotion/createpromotion",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_promotion(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatepromotion = createAsyncThunk(
  "promotion/updatepromotion",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_promotion(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletepromotion = createAsyncThunk(
  "promotion/deletepromotion",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_promotion({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const promotionSlice = createSlice({
  name: "promotions",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    updateFilterData(state, action) {
        const { name, value } = action.payload;
        state.filterData[name] = value;
      },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const {
        id,
        from_school_class,
        from_section,
        from_session,
        to_school_class,
        to_section,
        to_session,
        remarks,
        students
      } = action.payload;
      state.formData = {
        id,
        from_school_class,
        from_section,
        from_session,
        to_school_class,
        to_section,
        to_session,
        remarks,
        students
      };
    },
    resetFormData(state) {
      state.formData = {
        from_school_class :"",
    from_section :"",
    from_session :"",
    to_school_class :"",
    to_section :"",
    to_session :"",
    remarks :"",
      };
    },
    setpromotion(state, action) {
      state.promotions = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Classes
      .addCase(fetchpromotion.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchpromotion.fulfilled, (state, action) => {
        state.loading = false;
        state.promotions = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchpromotion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.promotions = [];

      })

      // Add Class
      .addCase(createpromotion.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createpromotion.fulfilled, (state, action) => {
        state.addLoading = false;
        state.promotions = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createpromotion.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updatepromotion.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatepromotion.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatepromotion.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deletepromotion.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletepromotion.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletepromotion.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setpromotion,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
  updateFilterData,
} = promotionSlice.actions;
export default promotionSlice.reducer;
